import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useQuery } from '../../../global/hooks/useQuery';
import { TcsmSiteSettingsProps } from '../../../global/models/epi-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { PodNavOption, usePodNavOptions } from '../hooks/usePodNavOptions';
import { MyCpgPodsTypes } from '../mycpg-pod-models';



export const PodNavigation = () => {
	const history = useHistory();
	const container = useRef(null);
	const [ariaExpand, setAriaExpand] = useState(false);
	const [ariaHidden, setAriaHidden] = useState(true);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const options = usePodNavOptions();
	const type = useQuery()?.get('type') as MyCpgPodsTypes;

	const close = () => {
		setAriaExpand(false);
		setAriaHidden(true);
	};

	const open = () => {
		setAriaExpand(true);
		setAriaHidden(false);
	};

	const handleTriggerClick = () => {
		if (ariaExpand && !ariaHidden) {
			close();
		} else {
			open();
		}

	};

	const handleOutsideClick = (e: Event) => {
		if (!container?.current?.contains(e.target as HTMLElement)) {
			close();
		}
	};

	useEffect(() => {
		window.addEventListener('click', handleOutsideClick);
	}, [container]);

	const onChange = (item: PodNavOption) => {
		history.push(item?.value);
		close();
	};

	const defaultValue = options?.find(a => a?.type === type);

	return (
		<>
			<p className='nav-secondary-label'><strong>{siteSettings?.secondaryNavLabel}</strong></p>
			<div ref={container} className='nav-secondary'>
				<button type='button' className='nav-secondary-trigger ' aria-expanded={ariaExpand} onClick={handleTriggerClick}> <span>{defaultValue?.text}</span><svg className='info-icon' focusable='false'>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#small-chevron-icon' />
				</svg></button>
				<div className='nav-secondary-panel' aria-hidden={ariaHidden}>
					<ul>
						{options?.map(l => { return <li><button type='button' className='nav-secondary-link' onClick={() => onChange(l)}>{l.text}</button></li>; })}
					</ul>

				</div>
			</div>

		</>
	);
};